define.alias("ember-cli-string-helpers/helpers/trim", "preview-grid/helpers/trim");